import React from 'react';
import { Routes, Route, Link as RouterLink } from 'react-router-dom';
import { Box, Container, Flex, HStack, Heading, Link, Spacer, Button } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { getClubInfo, ClubInfo } from './services/eshopApi';
import ShopHomePage from './pages/ShopHomePage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import SetupPage from './pages/SetupPage';
import OrderSuccessPage from './pages/OrderSuccessPage';
import SupportChatWidget from './components/SupportChatWidget';

const App: React.FC = () => {
  const { data: clubInfo } = useQuery<ClubInfo>(['eshop-club-info'], getClubInfo);
  const shopName = clubInfo?.club_name ? `${clubInfo.club_name} E-shop` : 'MyClub E-shop';
  const headerBg = clubInfo?.primary_color || 'gray.900';

  return (
    <Flex direction="column" minH="100vh">
      <Box as="header" borderBottomWidth="1px" py={3} bg={headerBg} color="white">
        <Container maxW="6xl">
          <HStack spacing={4} align="center">
            <Heading size="md">
              <Link as={RouterLink} to="/" _hover={{ textDecoration: 'none', opacity: 0.9 }}>
                {shopName}
              </Link>
            </Heading>
            <HStack as="nav" spacing={4} fontSize="sm">
              <Link as={RouterLink} to="/" _hover={{ opacity: 0.85 }}>Produkty</Link>
              <Link as={RouterLink} to="/cart" _hover={{ opacity: 0.85 }}>Košík</Link>
            </HStack>
            <Spacer />
            <Button as={RouterLink} to="/admin" size="sm" variant="outline" colorScheme="whiteAlpha">
              E-shop admin
            </Button>
          </HStack>
        </Container>
      </Box>

      <Box as="main" flex="1" py={6} bg="gray.50">
        <Container maxW="6xl">
          <Routes>
            <Route path="/" element={<ShopHomePage />} />
            <Route path="/produkt/:slug" element={<ProductDetailPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/objednavka/dekujeme" element={<OrderSuccessPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/setup" element={<SetupPage />} />
          </Routes>
        </Container>
      </Box>

      <SupportChatWidget />

      <Box as="footer" borderTopWidth="1px" py={4} bg="white" fontSize="sm" color="gray.500">
        <Container maxW="6xl">
          &copy; {new Date().getFullYear()} MyClub E-shop.
        </Container>
      </Box>
    </Flex>
  );
};

export default App;
